<template>
  <div>
    <div class="modal-overlay" @click="closeRatesModal" v-if="open"></div>
    <div class="return-rates-modal-container" :class="[open ? 'open' : 'closed']">
      <h1>RATES</h1>
      <h2>
        Outbound service is not available for return.  Please select a different service.
      </h2>
      <table>
        <tr>
          <th>Carrier</th>
          <th class="service-header">Service</th>
          <th>Delivery Date</th>
          <th class="cost-header">List Cost</th>
          <th class="cost-header">Neg Cost</th>
          <th>&nbsp;</th>
        </tr>
        <tr
          v-for="(rate, i) in rates"
          :key="i"
          @click="
            selectRate(
              rate.carrier_id,
              rate.carrier_service_id,
              rate.delivery_date,
              rate.ship_date
            )
          "
        >
          <td class="rate-item">{{ rate.carrier }}</td>
          <td class="rate-service">{{ rate.service }}</td>
          <td class="delivery-date">{{ rate.delivery_date }}</td>
          <td class="cost-item">{{ rate.total_net_charge }}</td>
          <td class="cost-item">{{ rate.total_cost }}</td>
          <td>
            <button class="btn btn-primary">Select Rate</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: ["rates", "open", "loading"],
  methods: {
    closeRatesModal() {
      this.$emit("closeRatesModal");
    },
    selectRate(carrierId, carrierServiceId, delivery_date, ship_date) {
      this.$emit(
        "returnRateSelected",
        carrierId,
        carrierServiceId,
        delivery_date,
        ship_date
      );
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

td,
th {
  padding: 0.7rem;
}

tr {
  border-bottom: 1px solid black;
}

.open {
  opacity: 1;
  top: 50%;
  transition: 0.3s ease-in-out;
}

.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.rate-service,
.service-header {
  text-align: left;
}

.cost-item,
.cost-header {
  text-align: right;
  width: 55px;
}

.return-rates-modal-container {
  position: fixed;
  z-index: 3;
  left: 50%;
  height: 500px;
  width: 660px;
  text-align: center;
  background: white;
  margin-left: -330px;
  border-radius: 20px;
  margin-top: -250px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

h1 {
  padding: 1rem;
  margin: 0;
  background: lightgrey;
  border-bottom: 1px solid black;
}
</style>
